export default "https://cdn-static.gokick.com/assets/9c92702f75f0b67707db9d869eecabb5f21facb9/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";